export const STUDIO_TEXT_LIMITS = {
  name: 100,
  tagline: 100,
  summary: 300,
  statusKey: 80,
  statusOption: 100,
  statusInitial: 1000,
  statusRule: 2000,
  commandKey: 50,
  commandTitle: 100,
  place: 100,
  placeNote: 2000,
  startName: 100,
  suggestion: 300,
  habit: 500,
  forbidden: 200,
  forbiddenCount: 30,
  sceneTitle: 100,
  sceneSituation: 100,
} as const
